import api from './client';

export const entityModelerApi = {
  ownership: (entityId: string) => api.get(`/entity-modeler/ownership/${entityId}`),
  setOwnership: (entityId: string, stakes: any[]) =>
    api.post(`/entity-modeler/ownership/${entityId}`, { stakes }),
  events: (entityId: string) => api.get(`/entity-modeler/events/${entityId}`),
  createEvent: (entityId: string, eventType: string, parameters: any) =>
    api.post(`/entity-modeler/events/${entityId}`, { eventType, parameters }),
  compliance: (entityId: string) => api.get(`/entity-modeler/compliance/${entityId}`),
  summary: () => api.get('/entity-modeler/summary'),
};
